module.exports = __webpack_public_path__ + "img/4-1.1fa327cc.svg";